import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const data = require('./time_table.json');
// curl -O https://holidays-jp.github.io/api/v1/date.json
const holidays = require('./date.json');

ReactDOM.render(
  <React.StrictMode>
    <App data={data} holidays={holidays} />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
